module.exports = __webpack_public_path__ + "static/media/app-bg-original.35e47799.jpg";